import { Box } from "@mui/material";
import styles from "./styles";

interface IProps {
  classes?: any;
}

const BlocBackground = (props: IProps) => (
  <Box className={"container"} sx={styles}>
    <div className={"texte"}>
      <h2> Labélisation en 2021 Finance Innovation </h2>
    </div>
  </Box>
);

export default BlocBackground;
